import { forwardRef, type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

export interface CellContentProps extends ComponentProps<'div'> {}

const CellContent = forwardRef<HTMLDivElement, CellContentProps>(function CellContent(
  { className, children, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={twMerge(
        'bg-background-subtle corner-smooth basis-full flex-col gap-2 rounded-xl border',
        'text-foreground-placeholder relative flex min-w-0 cursor-text p-2.5 text-sm',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
})

export { CellContent }
